import { Maybe } from 'graphql/jsutils/Maybe';
import React from 'react';
import { Link } from 'react-router-dom';
import cart from 'src/assets/svg/order/cart.svg';
import { PrimaryButton } from 'src/shared/design-system/Buttons';
import { Paragraph } from 'src/shared/design-system/Text';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';
import { FontSize, FontWeight } from 'web-common/src/shared/styles/font';
import { CheckoutIconWrapper } from '../cartUtilities';

const FullWidthLink = styled(Link)`
  display: flex;
  flex: 1;
  width: 100%;
`;

const CartButton = styled(PrimaryButton)`
  padding: ${Spacing.NONE} ${Spacing.SINGLE_QUARTER};
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  height: ${Spacing.TRIPLE};
  font-size: ${FontSize.XS};
`;

const CheckoutTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

interface IMobileCartButtonProps {
  quantity: number;
  title: string;
  subtitle?: Maybe<string>;
  to?: { pathname: string; search: string };
  onClick?: () => void;
  className?: string;
}

export const ConsumerOrderCartButton: React.FC<IMobileCartButtonProps> = ({
  title,
  subtitle,
  quantity,
  to,
  onClick,
  ...props
}) => {
  const Button = (
    <CartButton fluid onClick={onClick} {...props}>
      <CheckoutIconWrapper>
        <img src={cart} width='16px' height='16px' alt='Shopping Cart' />
      </CheckoutIconWrapper>
      <CheckoutTitleContainer>
        <Paragraph size={FontSize.S} weight={FontWeight.SEMI_BOLD} margin='0' white bold>
          {title}
        </Paragraph>
        {subtitle && (
          <Paragraph size={FontSize.XXS} margin='0' white bold>
            {subtitle}
          </Paragraph>
        )}
      </CheckoutTitleContainer>
      <CheckoutIconWrapper>
        <Paragraph size={FontSize.S} margin='2px 6px 0 0' white>
          {`${quantity}`}
        </Paragraph>
      </CheckoutIconWrapper>
    </CartButton>
  );

  return to ? <FullWidthLink to={to}>{Button}</FullWidthLink> : Button;
};
